<template>
  <fragment>
    <app-header title="Screens">
      <template #actions>
        <button
          v-if="$isA('admin')"
          class="btn btn-primary mt-2 mt-xl-0"
          type="button"
          @click="openAddScreen"
        >
          <i class="far fa-plus"></i> Screen
        </button>
      </template>
    </app-header>

    <div class="container">
      <screens-list-filters v-model="params" />

      <div class="card card-data-builder mt-3">
        <ul v-if="$isA('admin')" id="horizontal-nav" class="nav nav-horizontal">
          <li class="nav-item" :class="{ active: !archived }">
            <a class="nav-link" href="#" @click="archived = false">Active</a>
          </li>
          <li class="nav-item" :class="{ active: archived }">
            <a class="nav-link" href="#" @click="archived = true">Archived</a>
          </li>
        </ul><!-- /#horizontal-nav -->

        <c-data-list :items="screens" @load="load" class="list-data-screens mt-0">
        <template #columns>
          <div class="col-xl-3">Name</div>
          <div class="col-xl-3 flex-grow-1">Tags</div>
          <div class="col-xl-2">Media Owner</div>
          <div class="col-xl-2">Current Brightness</div>
          <div class="col-xl-2">Ambient Brightness</div>
        </template>

        <template #default="{ item }">
          <screens-list-item :screen="item" />
        </template>
        </c-data-list>
      </div>
    </div>
    <add-screen ref="addScreen" @saved="handleScreenSaved" />
  </fragment>
</template>

<script>
import { helperComputed, helperMethods } from '@/vuex/modules/screens'
import { compareQueryParams } from '@codium/codium-vue'
import ScreensListItem from './ScreensListItem'
import ScreensListFilters from './ScreensListFilters'
import AddScreen from './AddScreen'

export default {
  components: {
    ScreensListItem,
    ScreensListFilters,
    AddScreen
  },

  data () {
    return {
      params: null,
      archived: false
    }
  },

  watch: {
    params: compareQueryParams(async function (params) {
      await this.getScreens({ params: this.queryParams, fresh: true })
    }),

    archived () {
      this.refresh()
    }
  },

  computed: {
    ...helperComputed,

    queryParams () {
      const params = this.params ? { ...this.params } : {}
      if (this.archived) {
        params.archived = true
      }
      return params
    }
  },

  beforeDestroy () {
    this.resetScreens()
  },

  methods: {
    ...helperMethods,

    async refresh () {
      await this.getScreens({ params: this.queryParams, fresh: true })
    },

    async load (done) {
      const params = this.queryParams

      try {
        await this.getScreens({ params })

        done()
      } catch {
        done(true)
      }
    },

    openAddScreen () {
      this.$refs.addScreen.open()
    },

    async handleScreenSaved (screen) {
      if (screen?.id) {
        await this.$router.push({ name: 'screens.single', params: { screenId: screen.id } })
        return
      }

      await this.getScreens({ params: this.params, fresh: true })
    },

  }
}
</script>
